import Image from "next/image"
import Link from "next/link"

export const Logo = () => {
    return  <Link
    href="/"
    className={'flex items-center justify-start gap-4 bg-black'}
  >
    <div className={`flex flex-col gap-2 items-end justify-start relative`}>
      <Image
        src={'/images/logo/logo full.svg'}
        alt={'logo'}
        width={128}
        height={37}
        className={'z-[9999]'}
      />
      
    </div>
   
  </Link>
}